<app-header />
<app-update-banner />
<app-workstation-indicator />
<main #main>
    <router-outlet />
</main>
@if (web) {
    <app-scan-emulator />
}
@if (deviceFacade.locked()) {
    <app-lock />
}
